import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CadastrarFeriado from '../../components/Feriado/CadastrarFeriado'

const mapStateToProps = (store) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarFeriado)
